<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="states"
      :search="searchField"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 nowrap-headers"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index == activeRow }"
          class="tableRowColor"
          @click="activeRow = index"
        >
          <td class="text-xs">
            {{ item.name }}
          </td>
          <td class="text-xs">
            {{ item.language }}
          </td>
          <td>
            <flag :iso="item.flag" style="font-size: 25px" />
          </td>
          <td
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            class="justify-center"
          >
            <v-icon
              class="mr-2 pointer"
              variant="text"
              color="grey-darken-2"
              @click="editState(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              class="pointer"
              variant="text"
              color="grey-darken-2"
              @click="deleteState(item._id)"
            >
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert
            class="mb-0"
            :value="true"
            type="error"
            variant="tonal"
            border="bottom"
          >
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  data: () => ({
    loading: false,
    searchField: "",
    headers: [
      {
        title: "",
        sortable: false,
        key: "name",
      },
      {
        title: "",
        sortable: false,
        key: "language",
      },
      {
        title: "",
        sortable: false,
        key: "flag",
      },
      {
        title: "",
        sortable: false,
      },
    ],
    states: [],
    activeRow: null,
    dialogDelete: false,
    stateToDelete: null,
  }),
  created() {
    this.getLocale();
    this.getStates();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t("states.table.name");
      this.headers[1].title = this.$t("states.table.language");
      this.headers[2].title = this.$t("states.table.flag");
      this.headers[3].title = this.$t("states.table.actions");
    },
    search(value) {
      this.searchField = value;
    },
    getStates() {
      this.loading = true;
      getRequest("/state/")
        .then((response) => {
          if (response) {
            this.states = response.states;
            this.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.loading = false;
          }
        });
    },
    editState(state) {
      this.$emit("edit", state);
    },
    deleteState(stateId) {
      this.stateToDelete = stateId;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/state/", `id=${this.stateToDelete}`)
        .then((response) => {
          if (response) {
            this.loading = false;
            this.stateToDelete = null;
            this.dialogDelete = false;
            this.getStates();
          }
        })
        .catch((error) => {
          if (error) {
            this.loading = false;
          }
        });
    },
  },
};
</script>
